import FaqDialog from './FaqDialog';

export default FaqDialog;
